import dayjs from "dayjs";

export const MEETING_ROOM_STATES = [
  {
    id: "disabled",
    color: "#CCC",
    backgroundColor: "#CCC",
    title: "不可预定",
    title_en: "Unreservable"
  },
  {
    id: "free",
    color: "#18FEFE",
    backgroundColor: "rgba(24, 254, 254, 0.2)",
    title: "可预定",
    title_en: "Free"
  },
  {
    id: "reserved",
    color: "#FBE947",

    backgroundColor: "rgba(251, 233, 71, 0.2)",
    title: "已预定",
    title_en: "Reserved"
  }
];

// 会议室占用情况
export const OCCUPANCY_STATES = [
  {
    id: "occupancy_free",
    color: "rgba(255, 255, 255, 0.7)",
    title: "无人",
    title_en: "Free"
  },
  {
    id: "occupancy_occupied",
    color: "rgba(255, 197, 18, 0.7)",
    title: "有人",
    title_en: "Occupied"
  }
];

/**
 * 两段时间是否相交
 * @param {Array} range1
 * @param {Array} range2
 */
export const isTimeRangeOverlapping = (range1, range2) => {
  return (
    !range1[0].isAfter(range2[1], "minute") &&
    !range1[1].isBefore(range2[0], "minute")
  );
};

/**
 * 获取会议室在[startAt, endAt]之间的第一个预定
 * @param {*} meeting
 * @param {*} startAt
 * @param {*} endAt
 * @returns
 */
export const getReservationBetween = (meeting, startAt, endAt) => {
  const { reservations = [] } = meeting;

  const currentReservation = reservations.find(x => {
    const reservationStartAt = dayjs.unix(x.start_at);
    const reservationEndAt = dayjs.unix(x.real_end_at);
    const isReserved = isTimeRangeOverlapping(
      [startAt, endAt],
      [reservationStartAt, reservationEndAt]
    );
    // console.log("***", this.props.room.name, isReserved, startAt.format('HH:mm'), endAt.format('HH:mm'), reservationStartAt.format('HH:mm'), reservationEndAt.format('HH:mm'))
    return isReserved;
  });

  // console.log("*** currentReservation", currentReservation)

  return currentReservation;
};

/**
 * 获取会议室在[startAt, endAt]之间的预定状态
 * @param {*} meeting
 * @param {*} startAt
 * @param {*} endAt
 * @returns
 */
export const getMeetingState = (meeting, startAt, endAt) => {
  const currentTime = dayjs();
  if (currentTime.isAfter(endAt)) {
    return "disabled";
  }
  const reservation = getReservationBetween(meeting, startAt, endAt);
  return reservation ? "reserved" : "free";
};

export const addMeetingState = meetingRoom => {
  const startAt = dayjs();
  const endAt = startAt.add(30, "second");
  const currentReservation =
    getReservationBetween(meetingRoom, startAt, endAt) || {};
  const nextReservation =
    getReservationBetween(
      meetingRoom,
      endAt.add(1, "minute"),
      endAt.endOf("day")
    ) || {};
  const reservedStatus =
    MEETING_ROOM_STATES.find(
      x => getMeetingState(meetingRoom, startAt, endAt) === x.id
    ) || {};
  const occupancyStatus =
    OCCUPANCY_STATES.find(x => x.id === x.occupancy_state) || {};
  let nextTitle = "空闲中/FREE";
  let nextText = "";
  if (currentReservation && currentReservation.id) {
    nextTitle = `${dayjs
      .unix(currentReservation.start_at)
      .startOf("minute")
      .format("HH:mm")}-${dayjs
      .unix(currentReservation.end_at)
      .startOf("minute")
      .format("HH:mm")}`;
    const minutes = dayjs
      .unix(currentReservation.end_at)
      .startOf("minute")
      .diff(dayjs().startOf("minute"), "minute");
    nextText = `${minutes}分钟后可预定`;
  } else {
    if (nextReservation && nextReservation.id) {
      const minutes = dayjs
        .unix(nextReservation.start_at)
        .startOf("minute")
        .diff(dayjs().startOf("minute"), "minute");
      nextText = `下一个会议${minutes}分钟后开始`;
    } else {
      nextText = "全天可预定";
    }
  }
  meetingRoom.statusBag = {
    reservedStatus,
    occupancyStatus,
    currentReservation,
    nextReservation,
    nextTitle,
    nextText
  };
};
